import React, { useState, useEffect } from 'react'
import useStyles from './styles'
import WidgetContainer from 'components/set/WidgetContainer/WidgetContainer'
import clsx from 'clsx'
import { isCurtainClosed, isCurtainClosing, isCurtainOpen } from 'utils/curtain'
import { useSelector } from 'react-redux'
import { getCurtainState } from 'redux/slices/curtain'
import { getShow } from 'redux/slices/liveShow'

const Curtain: React.FC = () => {
    const classes = useStyles()
    const [fullHeight, setFullHeight] = useState(false)
    const curtain = useSelector(getCurtainState)
    const show = useSelector(getShow)

    useEffect(() => {
        if (isCurtainClosing(curtain.value) || isCurtainClosed(curtain.value)) {
            setFullHeight(true)
        } else {
            setFullHeight(false)
        }
    }, [curtain.value])
    return (
        <div
            className={clsx(
                classes.curtainContainer,
                fullHeight && classes.fullHeight,
                isCurtainClosed(curtain.value) && classes.closedState,
                isCurtainOpen(curtain.value) && classes.curtainOpen,
            )}
        >
            <div className={clsx(classes.curtainBanner, fullHeight && classes.startAnimatingBanner)}>
                <div className={classes.bannerMessage}>
                    <p className={classes.heading}>{curtain.body.heading}</p>
                    <p className={classes.title}>{curtain.body.title}</p>
                    <p className={classes.message}>{curtain.body.message}</p>
                </div>
                {show && <img className={classes.artistPic} src={show.posterImg} alt={show.posterImg} />}
            </div>
            <WidgetContainer hideInMobile />
        </div>
    )
}
export default Curtain
